export default __webpack_public_path__ + "static/media/48px_paypal 1.976df1b7.svg";